import './StatusIndicator.scss'
import { ReactComponent as PencilIconSVG } from '../../../assets/pencil-icon.svg'
import { ReactComponent as LoadingSpinnerSVG } from '../../../assets/loading-spinner.svg'
import { ReactComponent as CircleCheckSVG } from '../../../assets/circle-check.svg'
import { ReactComponent as WarningSVG } from '../../../assets/warning.svg'
import { ReactComponent as XmarkSVG } from '../../../assets/cross.svg'
import { ReportStatusIndicatorEnum } from './useManageReports'

const { useMemo } = require('react')

export const StatusIndicator = ({ status }) => {
  const currentStatus = useMemo(
    () => (
      <section className='statusIndicator'>
        {status === ReportStatusIndicatorEnum.UNSAVED && (
          <section className=' status status-unsaved'>
            <span className='status-label'>Unsaved</span> <PencilIconSVG />
          </section>
        )}
        {status === ReportStatusIndicatorEnum.SAVING && (
          <section className=' status status-saving'>
            <span className='status-label'>Saving...</span> <LoadingSpinnerSVG />
          </section>
        )}
        {status === ReportStatusIndicatorEnum.SAVED && (
          <section className=' status status-saved'>
            <span className='status-label'>Saved</span> <CircleCheckSVG />
          </section>
        )}
        {status === ReportStatusIndicatorEnum.ERROR && (
          <section className=' status status-saved'>
            <span className='status-label'>Error</span> <XmarkSVG />
          </section>
        )}
        {status === ReportStatusIndicatorEnum.REPORT_NAME_DUPLICATED && (
          <section className=' status status-saved'>
            <span className='status-label'>Invalid Report </span> <WarningSVG />
          </section>
        )}
        {status === ReportStatusIndicatorEnum.VALIDATION_ERROR && (
          <section className=' status status-saved'>
            <span className='status-label'>Invalid Report</span> <WarningSVG />
          </section>
        )}
      </section>
    ),
    [status]
  )

  return currentStatus
}

export default StatusIndicator
